import { useEffect } from "react";
import { FONT_CATALOG, buildGoogleFontsHref } from "./meta";

const LINK_ID = "theme-nexus-font-catalog";
let injected = false;

/**
 * Precarga el catálogo completo (~70 Google Fonts) en una sola request.
 * Idempotente: si ya se inyectó el <link>, no hace nada. Sólo el editor
 * de tema lo necesita; el portal user carga sólo las 3 fuentes activas.
 */
export function useFontCatalog() {
  useEffect(() => {
    if (injected) return;
    if (document.getElementById(LINK_ID)) {
      injected = true;
      return;
    }
    const names = [
      ...FONT_CATALOG.serif.map((f) => f.name),
      ...FONT_CATALOG.sans.map((f) => f.name),
      ...FONT_CATALOG.mono.map((f) => f.name),
    ];
    const href = buildGoogleFontsHref(names);
    if (!href) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.id = LINK_ID;
    document.head.appendChild(link);
    injected = true;
  }, []);
}
